import React from 'react';

import { SomethingGoingWrong } from '../SomethingGoingWrong/SomethingGoingWrong';

// import { Loader } from './Loader';

import { RsdLoader } from './RsdLoader';
import style from './WithState.module.scss';


export const WithState = ({
  isFetching,
  onReload,
  isFailed,
  errorMessage,
  withReload,
  children,
  failedAdditions,
  reloadMessage,
  withBack = false,
  errorDetails
}) => (


  <div className={ style.wrapper }>
    {isFetching && !isFailed && <RsdLoader />}
    {isFailed && (
      <SomethingGoingWrong
        errorDetails={ errorDetails }
        additions={ failedAdditions }
        reload={ onReload }
        reloadMessage={ reloadMessage }
        errorMessage={ errorMessage }
        withReload={ withReload }
        withBack={ withBack }

      >
        {children}
      </SomethingGoingWrong>
    )}
    {!isFetching && !isFailed && children}
  </div>
);
